(function () {
  'use strict';
  var mod = angular.module('core');

  mod.directive('radio', [directiveInit]);

  function directiveInit() {
      function link(scope) {
          var hasLabel = Boolean(scope.labelProperty);
          scope.getLabel = function(data) {
              if(hasLabel) {
                  return data[scope.labelProperty];
              } else {
                  return data;
              }
          };
          if (!scope.model) {
            scope.model = scope.defaultValue;
          }
      }

      return {
          restrict: 'E',
          link: link,
          templateUrl: 'layout/radioTemplate.html',
          scope: {
              values: '=',
              model: '=',
              labelProperty: '@?',
              trackProperty: '@?',
              defaultValue: '@?',
              name: '@?',
          }
      };
  }
})();
